"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index2.js");exports.InfiniteScrollTrigger=e.default;
